/**
 * @generated SignedSource<<7ba20722542a99cba68679b89f570da6>>
 * @relayHash bd156ce7dcb05c63cda982fd3dc3a02d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a5a41ee8f57290e91c834aa4184613801303bc136eaf48487a001afe6bb60252

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentQuery } from './PopupContentQuery.graphql';

const node: PreloadableConcreteRequest<PopupContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a5a41ee8f57290e91c834aa4184613801303bc136eaf48487a001afe6bb60252",
    "metadata": {},
    "name": "PopupContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
